import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosError} from 'axios';
import {message} from 'antd';

import {axiosRequest} from '../../helpers/request';
import {IBusinessClass, TBusinessState, IRequestError} from './buisness-slice-types';

export const getBuisnessClass = createAsyncThunk<
    IBusinessClass[],
    undefined,
    {rejectValue: IRequestError}
>(
    "BUSINESS-CLASS/LIST", async (_, thunkApi) => {
        try {
            const config = {headers: {"Content-Type": "application/json"}};
            const res = await axiosRequest.get(`/public-api/get-business-classification`, config);
            return res.data;
        } 
        catch (err:any) {
            let error: AxiosError<IRequestError> = err;
            if(!error.response){
                throw err;
            }
            return thunkApi.rejectWithValue(error.response.data)
        }
    }
);

const businessSlice = createSlice({
    name: 'business',
    initialState: {
        status: 'idle',
        businessClass: [],
    } as TBusinessState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getBuisnessClass.pending, (state, _) => {
            state.status = 'pending';
        })
        builder.addCase(getBuisnessClass.fulfilled, (state, {payload}) => {
            state.businessClass = payload;
            state.status = 'succeeded';
        })
        builder.addCase(getBuisnessClass.rejected, (state, {payload, error}) => {
            state.businessClass = [];
            state.status = 'failed';
            if(payload?.detail){
                message.error(payload.detail);
            }else{
                message.error(error.message)
            }
        })
    },
});

export default businessSlice.reducer;
